import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { Application } from '@softline/application';
import { UiCoreModule } from '@softline/ui-core';

@Component({
  selector: 'soft-app-list',
  templateUrl: './app-list.component.html',
  styleUrls: ['./app-list.component.css'],
  imports: [UiCoreModule],
})
export class AppListComponent {
  @Input() application!: Application;
  @Output() navigate = new EventEmitter<Application>();
  showColor = input<boolean>(false);

  goToApplication(application: Application): void {
    this.navigate.emit(application);
  }
}
